<template>
  <div class="body_main">
    <div class="login-container">
      <div class="login-box">
        <div class="form">
          <h3 class="title">用户登录</h3>
          <el-form ref="loginForm" :model="loginForm" :rules="rules" label-position="left" label-width="0px">
            <el-form-item prop="account">
              <el-input maxlength="255" auto-complete="off" v-model="loginForm.account" placeholder="请输入手机号或账户">
                <img slot="prefix" class="iconimg" src="../assets/login/usericon.png" /></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="loginForm.password" auto-complete="off" placeholder="请输入密码">
                <img slot="prefix" class="iconimg" src="../assets/login/passwordicon.png" />
              </el-input>

            </el-form-item>
            <el-form-item>
              <el-button type="primary" class="login-button" @click.native.prevent="handleLogin"
                :loading="loading">登录</el-button>
            </el-form-item>
            <div class="reg-link">
              <a class="forget" href="#/findpassword">忘记密码？</a> 还没有账号？<a class="goreg" href="#/registerteam">注册代表队</a>
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div class="bottom-box">
      <img src="../assets/record.png" style="width: 24px;vertical-align: bottom;" alt="record"/>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=50010602504863" style="color: white;font-size: 14px;    line-height: 24px;
    display: inline-block;" rel="noreferrer" target="_blank">
       渝ICP备2021003187号-6
      </a>
    </div>
  </div>
</template>

<script>
import API from '../apis/user'

export default {
  data() {
    return {
      loading: false,
      loginForm: {
        account: '',
        password: ''
      },
      rules: {
        account: [
          { required: true, message: '请输入手机号或账户', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      checked: true
    }
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true
          let loginParams = {
            username: this.loginForm.account,
            password: this.loginForm.password
          }
          API.login(loginParams).then((result) => {
            if (result.code === 0) {
              sessionStorage.setItem('uid', result.result.uid)
              sessionStorage.setItem('token', result.result.access_token)
              sessionStorage.setItem('refresh_token', result.result.refresh_token)
              sessionStorage.setItem('userType', result.result.userType)
              if (result.result.awatar != null) {
                sessionStorage.setItem('awatar', result.result.awatar)
              }
              sessionStorage.setItem('name', result.result.name)
              var date = new Date()
              var tsTime = date.getTime()
              date.setTime(tsTime + result.result.expire * 60000)
              sessionStorage.setItem('expireTime', date)
              this.$router.push({ path: '/' })
            } else {
              this.$message.error({ showClose: true, message: result.message || '登录失败', duration: 2000 })
              this.loading = false;
            }
          }).catch((error) => {
            this.loading = false;
            this.$message.error({ showClose: true, message: '请求出现异常', duration: 2000 })
          })
        }
      })
    }
  },
  created() {
    document.onkeypress = (e) => {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        this.handleLogin();
        return false;
      }
    }
  },
  mounted() {
  }
}
</script>
<style lang="scss" scoped>
.body_main {
  height: 100%;
  width: 100%;
  background-image: url(../assets/login/loginbackground.jpg);
  position: relative;
  background-repeat: no-repeat;

  background-size: 100% 100%;

  background-attachment: fixed;
}

.login-container {
  background-image: url(../assets/login/loginboxbackground.png);
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -212px 0 0 -392px;
  background-clip: padding-box;
  background-repeat: no-repeat;
  width: 785px;
  height: 424px;

  .iconimg {
    width: 24px;
    vertical-align: middle;
  }

  .title {
    margin: 0px;
    text-align: left;
    color: #dfc16d;
    font-size: 20px;
    padding-top: 42px;
    margin-bottom: 30px;
  }

  .login-box {
    background-image: url(../assets/login/login.png);
    height: 100%;
    width: 100%;
    background-repeat: no-repeat;
  }

  .form {
    margin-left: 363px;
    max-width: 371px;
  }

  .login-button {
    background-image: url(../assets/login/btn.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-attachment: fixed;
    width: 100%;
    font-size: 18px;
    height: 50px;
    margin-top: 18px;
  }

  .reg-link {
    font-size: 14px;
    text-align: center;
  }

  .goreg {
    color: #dfc16d;
  }

  .forget {
    color: white;
    text-decoration: none;
  }

  .remember {
    margin: 0px 0px 35px 0px;
  }
}

.bottom-box {
  color: white;
  position: absolute;
  bottom: 50px;
  text-align: center;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue